var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeIlustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 379,
    viewBox: "0 0 437 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 165.011C183.5 167.811 167.5 169.011 167.5 168.011V166.511L170.5 165.011L186.5 156.011L196 143.011L198 135.011C198.5 134.511 200.4 133.611 204 134.011C203.6 150.811 194.5 159.344 190 161.511L204.5 170.011C199.167 169.677 187.9 168.211 185.5 165.011Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 22.511C266.3 41.311 260 54.3443 256.5 58.511L254.5 60.0107L240.5 47.0107L236 46.0107L237 51.0107L231 50.0107L223.5 41.5107L220 31.0107L205.5 34.511L194 27.5107L186.5 40.0107L170.5 51.0107L168 72.0107H163.5L159 66.5107L147 57.5107L141.5 58.511L135 64.0107L137.5 76.5107L145 82.5107V90.0107L154.5 107.011C136 109.511 130 94.011 131.5 87.511C118.5 57.011 133 46.511 133 45.011C136.6 26.611 149.5 20.6776 158 22.511C156.667 19.3443 160.3 11.9109 173.5 3.51094C186.7 -4.88906 202 3.67741 208.5 9.51074C209.667 7.34408 218 8.61101 230 11.011C245 14.011 240.5 28.511 249 34.511C257.5 36.511 261 30.511 263.5 22.511Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.5 299.011L316.5 207.011H389.5C397.5 207.011 370.5 275.011 356.5 309.011H230L232.5 304.511H279L282.5 299.011Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 260.011C140.3 234.011 156 185.844 164 165.011C155.2 148.211 161.333 129.011 165.5 121.511L156 127.511L122 166.511L104.5 212.011C100.667 228.011 92.6 262.211 91 271.011C100.2 272.611 122.167 263.344 132 258.511C134.333 259.011 139.5 260.011 141.5 260.011Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 270.511C101.167 237.844 101.1 165.111 165.5 121.511M132.5 258.511C147.5 259.677 178.3 263.711 181.5 270.511C184.7 277.311 191.167 305.344 194 318.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160 151.011C160.167 158.511 161.43 169.977 171 165.511C178.5 162.011 190 158.011 198.5 135.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190 161.511C195.5 166.344 206.8 173.911 208 165.511C209.5 155.011 207 135.011 204 134.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 122.011C167.833 128.011 178.8 138.711 204 133.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 133.511C212.167 137.844 229.8 151.511 239 167.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 275.011C192.985 275.337 219.261 266.326 234 254.511C235.03 253.685 236 252.511 239 251.011C248.5 249.511 259.5 254.511 262.5 257.511C264.9 259.911 261.167 260.177 259 260.011C253.5 257.677 241.4 255.211 237 264.011C240.5 266.511 256 266.011 257.5 291.011C257.5 299.511 248.5 283.011 245.5 279.011C243.1 275.811 235.833 273.344 232.5 272.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 281.011C249.167 285.011 252 293.311 250 294.511C247.5 296.011 244.5 294.511 243.5 292.011C242.5 289.511 240 282.011 226.5 279.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 284.511C240.333 288.844 243.6 297.611 242 298.011C240 298.511 230.987 288.585 228 288.011C225.88 287.603 224 286.511 219 289.511C214 292.511 205 300.011 196.5 296.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264 211.011L270.5 219.011C260 197.511 239.4 153.311 241 148.511C243 142.511 271.5 132.011 288 136.511C295.2 142.911 310.333 175.511 317 191.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M248 65.5106C243.167 59.3439 234.334 48.009 235 47.0106C236 45.5107 236.5 45.0106 238.5 46.0106C240.5 47.0106 257.935 62.9026 259.5 65.5106C261 68.0106 263 73.5106 262.5 77.5106C262 81.5106 254 93.5106 254 100.511C254 106.695 262.5 124.511 270.5 135.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244 61.0107C242.333 78.1774 233.8 114.711 213 123.511C187 134.511 164 115.011 156 107.011C151.333 102.177 142.7 90.6107 145.5 83.0107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 82.0107C149.666 84.5107 134.5 80.0107 134.5 67.0107C135 64.0107 135.968 62.0107 138 60.5107C147.5 53.0107 154.04 59.571 161 70.0107C169 82.0107 173.5 55.0107 169.5 51.5107C177.5 46.5107 189 42.5107 193.5 27.5107C202 33.0107 204 38.0107 220 30.5107C220.333 36.1774 224.2 48.3107 237 51.5107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189 67.5107C192 68.8441 199.2 71.1107 204 69.5107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 70.0107C214.833 71.0107 220.6 72.4107 225 70.0107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 69.5107C210.5 73.6774 210.7 83.6107 219.5 90.0107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193 105.511C197.667 107.011 208.3 108.711 213.5 103.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5 90.5107C218.5 91.5107 215.6 93.2107 212 92.0107",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 304.011H231.5L227.5 308.011C270 309.344 360.3 311.211 381.5 308.011C389.9 306.811 377 305.844 369.5 305.511C372.833 303.677 384.9 281.511 406.5 207.511C400.1 205.111 343.167 206.511 315.5 207.511C308.333 223.844 291.5 265.111 281.5 299.511",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M394.5 271.511H434.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2 266.511H69",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M355.137 259.161C353.558 261.306 351.487 262.752 349.434 263.37C347.381 263.989 345.38 263.775 343.867 262.661C342.355 261.547 341.556 259.7 341.537 257.556C341.518 255.412 342.284 253.005 343.863 250.86C345.442 248.715 347.513 247.269 349.566 246.651C351.619 246.033 353.62 246.247 355.133 247.361C356.645 248.474 357.444 250.322 357.463 252.465C357.482 254.609 356.716 257.016 355.137 259.161Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104 270.011C107.333 270.677 113.6 273.911 112 281.511C110 291.011 105.679 289.606 100.5 296.511C99 298.511 95.9999 309.511 118 311.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127 320.511C120.167 321.511 102.3 323.211 85.5 322.011C64.5 320.511 75 340.011 84 340.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 325.511C133.667 344.011 132.5 375.511 115 375.511C95.22 375.511 93 352.011 92 323.011",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110 367.511C102.856 364.653 99.5 346.677 99 337.011L126 335.011C127.5 367.011 115 369.511 110 367.511Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 376.011C94.1 379.211 106.5 379.011 115 377.511L102.5 371.011C92.5 371.344 74.9 372.811 84.5 376.011Z",
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.628,
    cy: 252.576,
    rx: 2.5,
    ry: 4.02709,
    transform: "rotate(16.2269 352.628 252.576)",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 179.011,
    r: 4,
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_105_191)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8385 108.905C26.6064 106.413 26.4599 103.566 25.2162 100.938C22.6954 95.611 16.6214 93.1999 11.6496 95.5526C6.6777 97.9054 4.69074 104.131 7.21156 109.458C8.45522 112.086 10.5637 114.005 12.978 114.991L37.4079 166.616C38.1166 168.114 39.9052 168.754 41.4029 168.045L48.8399 164.526C50.3376 163.817 50.9771 162.028 50.2684 160.531L48.7127 157.243C53.0327 154.878 59.853 151.746 64.8542 151.438C72.5016 150.967 89.7599 147.523 98.1537 141.977C103.576 138.394 102.226 135.589 101.576 134.239C101.552 134.189 101.529 134.14 101.507 134.094L82.9449 94.8693C82.765 93.3804 81.1192 91.0111 75.975 93.4455C69.5447 96.4883 60.5424 100.748 46.4992 102.672C36.6715 104.018 29.648 107.811 26.4494 110.196L25.8385 108.905Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3223 122.633L71.0173 145.953C70.5384 145.994 70.0591 146.027 69.5781 146.053C65.7868 146.259 62.0813 146.946 58.5074 148.102L58.5056 148.102C58.3578 148.01 48.8677 142.105 42.9186 129.534C36.9225 116.863 39.5862 108.118 39.5862 108.118C43.574 106.761 47.7149 105.942 51.9564 105.674C51.9862 105.672 52.0174 105.669 52.0472 105.668L75.3223 122.633Z",
    fill: "#F4E7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9961 119.128C86.7194 131.223 83.2744 143.27 83.2744 143.27C79.326 144.701 75.2244 145.599 71.0172 145.953L51.9563 105.674C51.9862 105.672 52.0173 105.669 52.0472 105.668L52.3353 105.65C56.4503 105.396 60.4644 104.576 64.314 103.203C64.314 103.203 75.2723 107.033 80.9961 119.128Z",
    fill: "#EEDBCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2446 98.2129L97.4203 134.509C97.9124 135.549 97.4679 136.792 96.428 137.284L87.4872 141.515C86.1044 142.169 84.6995 142.754 83.2744 143.27L64.314 103.203C65.6888 102.714 67.0428 102.155 68.374 101.525L77.4693 97.2206C78.5092 96.7285 79.7525 97.1731 80.2446 98.2129Z",
    fill: "#FF415B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5861 108.118L58.5073 148.102C56.703 148.685 54.9385 149.385 53.225 150.196L43.4051 154.843L24.5059 114.905L34.4803 110.185C36.1494 109.395 37.8536 108.706 39.5861 108.118Z",
    fill: "#A8D445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3305 124.19L64.1724 131.489C60.9171 133.029 57.0169 131.635 55.4764 128.379C53.9359 125.124 55.3306 121.224 58.5859 119.683L64.3305 124.19Z",
    fill: "#5B362A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.282 122.793C68.8224 126.048 67.4278 129.948 64.1725 131.489L58.5859 119.683C61.8412 118.143 65.7415 119.538 67.282 122.793Z",
    fill: "#512C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.888 122.174L43.9229 158.172L43.1775 162.483L41.0425 163.493C40.0026 163.985 38.7592 163.541 38.2672 162.501L16.3369 116.158L20.3558 114.256L26.888 122.174Z",
    fill: "#66433C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3746 112.354L46.3049 158.697C46.797 159.737 46.3524 160.981 45.3125 161.473L43.1774 162.483L20.3557 114.256L24.3746 112.354Z",
    fill: "#5B362A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.274 103.255L18.454 110.237C15.1246 111.813 11.1615 110.419 9.60205 107.123C8.04316 103.829 9.41916 99.7561 12.7486 98.1806L19.274 103.255Z",
    fill: "#F6DF5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6587 101.418C23.2182 104.713 21.7834 108.662 18.454 110.237L12.7485 98.1805C16.0779 96.605 20.0998 98.1235 21.6587 101.418Z",
    fill: "#F0CA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6824 111.174L20.3558 114.256L16.2113 116.217C15.1714 116.71 13.9281 116.265 13.436 115.225L12.8417 113.969C12.3496 112.929 12.7942 111.686 13.8341 111.194L17.9785 109.233L21.6824 111.174Z",
    fill: "#F0CA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8983 108.264L25.4927 109.52C25.9848 110.559 25.5402 111.803 24.5003 112.295L20.3558 114.256L17.9785 109.233L22.123 107.271C23.1629 106.779 24.4062 107.224 24.8983 108.264Z",
    fill: "#E4A637"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_105_191",
    x: 3.11841,
    y: 90.3971,
    width: 102.095,
    height: 81.9369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.1388,
    height: 71.1388,
    fill: "white",
    transform: "translate(5.15039 101.776) rotate(-25.3243)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeIlustration);
export default __webpack_public_path__ + "static/media/me_ilustration.edfcbbe439659127be8c6dd15a70b7f7.svg";
export { ForwardRef as ReactComponent };